// Production
export const contactFlowId = '325c11f8-636d-444d-bde1-0c096cfe3077'
export const instanceId = 'a351243b-6844-41b0-97d9-934414342d87'
export const apiGatewayEndpoint = 'https://sbrblsycca.execute-api.us-east-1.amazonaws.com/Prod/'
export const contactAttributeAPIGateway = 'https://ja4tyz6qm6.execute-api.us-east-1.amazonaws.com/prod'
export const awsRegion = 'us-east-1'
